<div class="container" id="wrap">
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12">
        <div class="col-lg-3"></div>
        <div class="col-lg-6 text-center ">
            <img src="assets/images/logos/ic.svg" style="width: 70%;">
        </div>
        <div class="col-lg-3"></div>
    </div>
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12 form-horizontal">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
            <div class="bg-registro-light" style="padding-top: 10px;padding-bottom: 10px; overflow: hidden;">
                <div [formGroup]="fmGroup">
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label>Contraseña actual <small class="text-muted f11"><em></em></small></label>
                            <input #xPass name="password" [readonly]="this.disable" formControlName="password" type="password" placeholder="Vuelve a ingresar tu contraseña" class="form-control input-md placeholder-input input-form-usuario-registro" minlength="6" required [ngClass]="{'is-valid': fmGroup.get('password').valid, 'is-invalid':fmGroup.get('password').invalid && (fmGroup.get('password').dirty) }">
                            <span (click)="xPass.type = xPass.type == 'password' ? 'text' : 'password'" class="{{xPass.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'}}"></span>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label>Nueva contraseña <small class="text-muted f11"><em>(Debe contener mínimo 6
                                        caracteres)</em></small></label>
                            <input #xnewPass name="newPassword" [readonly]="this.disable" formControlName="newPassword" type="password" placeholder="Vuelve a ingresar tu contraseña" class="form-control input-md placeholder-input input-form-usuario-registro" minlength="6" required [ngClass]="{'is-valid': fmGroup.get('newPassword').valid, 'is-invalid':fmGroup.get('newPassword').invalid && (fmGroup.get('newPassword').dirty) }">
                            <span (click)="xnewPass.type = xnewPass.type == 'password' ? 'text' : 'password'" class="{{xnewPass.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'}}"></span>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                    <div class="col-lg-12">
                        <div class="col-lg-2"></div>
                        <div class="form-group col-lg-8">
                            <label>Confirmar contraseña</label>
                            <input #xConfPass name="confirmpassword" [readonly]="this.disable" formControlName="confirmpassword" type="password" placeholder="Vuelve a ingresar tu contraseña" class="form-control input-md placeholder-input input-form-usuario-registro" minlength="6" required [ngClass]="{'is-valid': fmGroup.get('confirmpassword').valid, 'is-invalid':fmGroup.get('confirmpassword').invalid && (fmGroup.get('confirmpassword').dirty) }">
                            <span (click)="xConfPass.type = xConfPass.type == 'password' ? 'text' : 'password'" class="{{xConfPass.type == 'password' ? 'fa fa-eye-slash field-icon' : 'fa fa-eye field-icon'}}"></span>
                        </div>
                        <div class="col-lg-2"></div>
                    </div>
                </div>

                <div class="col-lg-12 mobile-content-show">
                    <div class="col-lg-2"></div>
                    <div class="form-group col-lg-8">
                        <button [disabled]="!fmGroup.valid || this.disable" (click)="onResetPassword()" class="col-xs-6" class="btn btn-lg btn-orange btn-block m0top">Crear contraseña</button>
                    </div>
                    <div class="col-lg-2"></div>
                </div>
            </div>

            <div class="col-lg-12">
                <br />
            </div>

            <div class="col-lg-12">
                <div class="col-lg-6">
                    <button (click)="back()" class="btn btn-lg btn-atras btn-block m0top">Volver</button>
                </div>
                <div class="col-lg-6 mobile-content-hide">
                    <button [disabled]="!fmGroup.valid || this.disable" (click)="onResetPassword()" type="submit" class="btn btn-lg btn-orange btn-block m0top">Modificar
                        contraseña</button>
                </div>
            </div>

        </div>
        <div class="col-lg-3"></div>
    </div>
</div>